/**
 * @flow
 * @author: VaraKumar
 */

import styled from 'react-emotion'

import { mobile, tablet, mdDesktop } from '../../../../utils/mixins'

import CloudinaryS3LazyLoadedImage from '../../../CloudinaryS3LazyLoadedImage'

export const MainContainer = styled('div')`
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  width: 100%;
  ${mobile} {
    display: block;
    margin-bottom: ${props => (props.excludeBottomMargin ? 0 : '12px')};
  }
  ${tablet} {
    margin-bottom: ${props => (props.excludeBottomMargin ? 0 : ' 0.9375em')};
    display: block;
  }
  ${mdDesktop} {
    margin-bottom: ${props => (props.excludeBottomMargin ? 0 : ' 0.9375em')};
    display: block;
  }
`

export const ThumbnailImgContainer = styled(CloudinaryS3LazyLoadedImage)`
  height: auto;
  width: 100%;
  height: 214px;
  object-fit: cover;
`

export const ThumbnailImgSection = styled('div')``

export const ThumbnailVideo = styled('video')``



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/PortfolioSection/VideoTestimonial/styledComponents.js